import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import TeamMemberCard from "../TeamMemberCard";
import BioModal from "../BioModal";

// data
import { memberDetails } from "../MemberDetails";

// styles
import * as styles from "./ExecutiveTeamNew.module.css";

const teamDetails = [
  {
    id: "jahangir-mohammed",
    drName: "Jahangir Mohammed",
    designation: "Founder/Global CEO",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/jahangir_v2.png"
        alt="Jahangir Mohammed"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "maluk-mohamed",
    drName: "Maluk Mohamed",
    designation: "Co-Founder/VP Research/Head(India)",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/maluk_v2.png"
        alt="Maluk Mohamed"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "terry-poon",
    drName: "Terry Poon",
    designation: "Co-Founder, EVP & CTO",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/terry_v2.png"
        alt="Terry Poon"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "lisa-shah-md",
    drName: "Lisa Shah, MD",
    designation: "EVP & Chief Medical Officer",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/lisa_v2.png"
        alt="Lisa Shah"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "tom-samuelson",
    drName: "Tom Samuelson",
    designation: "CFO, Finance",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/tom_samuelson.png"
        alt="Tom Samuelson"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "jen-bealer",
    drName: "Jen Bealer",
    designation: "Chief Legal Officer",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/jen_v2.png"
        alt="Jen Bealer"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
];

const ExecutiveTeamNew = ({
  title = "Executive Team",
  members = teamDetails,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const handleReadBio = member => {
    // Find full member details from memberDetails
    const fullMemberData = memberDetails.find(m => m.id === member.id);

    if (fullMemberData) {
      setSelectedMember(fullMemberData);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMember(null);
  };

  return (
    <>
      <section className={styles.executiveTeamSection}>
        <div
          className={`container scroll_animate ${inView && "inview"}`}
          ref={ref}
        >
          {/* Heading */}
          <div className="row">
            <div className="col-12">
              <h2 className={styles.sectionTitle}>{title}</h2>
            </div>
          </div>

          {/* Team Members Grid */}
          <div className={`row ${styles.teamGrid}`}>
            {members.map((member, index) => (
              <div key={index} className="col-6 col-md-6 col-lg-4">
                <TeamMemberCard member={member} onReadBio={handleReadBio} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bio Modal */}
      <BioModal
        show={showModal}
        onHide={handleCloseModal}
        member={selectedMember}
      />
    </>
  );
};

ExecutiveTeamNew.propTypes = {
  title: PropTypes.string,
  members: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      drName: PropTypes.string.isRequired,
      designation: PropTypes.string.isRequired,
      company: PropTypes.string,
      drImage: PropTypes.node.isRequired,
    })
  ),
};

export default ExecutiveTeamNew;
